@if (leftCornerData) {
  <section class="left-corner">
    <div>
      @if (leftCornerData.icon) {
        <svg-icon preserveAspectRatio="none" [src]="leftCornerData.icon" [stretch]="true"></svg-icon>
      }

      @if (leftCornerData.titleText) {
        @if (isTitleTextType()) {
          @if (leftCornerData.titleParams) {
            <span class="left-corner-text ellipsis" translate [translateParams]="leftCornerData.titleParams">
              {{ leftCornerData.titleText }}
            </span>
          } @else {
            <span class="left-corner-text ellipsis" [innerHTML]="leftCornerData.titleText"></span>
          }
        } @else {
          <ng-container *ngTemplateOutlet="leftCornerData.titleText"></ng-container>
        }
      }
    </div>
  </section>
}
<section class="base-modal-header">
  @if (iconPath) {
    <svg-icon class="h-12 w-12" [src]="iconPath"></svg-icon>
  }

  @if (titleTranslationKey) {
    <span class="title">
      <app-text [text]="titleTranslationKey" [textParameters]="titleTranslationParams"></app-text>
    </span>
  }

  @if (descriptionTemplate) {
    <section class="description">
      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
    </section>
  }

  @if (descriptionTranslationKey) {
    <span class="description">
      <app-text [text]="descriptionTranslationKey" [textParameters]="descriptionParams"></app-text>
    </span>
  }
</section>

<section class="base-modal-content overflow-auto">
  <ng-content></ng-content>
</section>

@if (footerTemplate) {
  <section class="base-modal-footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </section>
}
